import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = [];

  connect() {
    console.log("connected formularcenter_controller.js");
    // Create a new button element
    this.button = document.createElement('button');

    // Set button properties
    this.button.textContent = 'Direkte Downloadlinks anzeigen';
    this.button.classList.add('btn', 'btn-primary');
    this.button.addEventListener('click', this.downloadAllForms.bind(this));

    // Append the button to the controller's element
    this.element.insertAdjacentElement('afterbegin', this.button);
  }
  downloadAllForms() {
    // Implement the logic to download all forms here
    console.log("Downloading all forms...");

    // Find all links pointing to formularserver.bayern.de or relative links
    const allLinks = this.element.querySelectorAll('a');
    const formLinks = Array.from(allLinks).filter(link => {
      const href = link.getAttribute('href');
      return href && (href.includes('formularserver.bayern.de') || !href.startsWith('http'));
    });
    // Find all links pointing to formularserver.bayern.de
    //const formLinks = document.querySelectorAll('a[href*="formularserver.bayern.de"]');

    // Create an array to store all the URLs
    const formUrls = [];
    var i = 0;
    const formLinksCount = formLinks.length;

    // Loop through all links and retrieve the full URL
    formLinks.forEach(function(link) {
      //   // link.click();
      const url = link.href; // Get the full URL
      var downloadUrl = url;
      var clicktext = 'Klicken um von schule-oberfranken.de herunterzuladen';
      var downloadAttribute = 'download';
      if(url.match(/formularserver\.bayern\.de/)) {
        downloadUrl = downloadUrl.replace(/\/index?.*$/, '/download');
        clicktext = 'Klicken um von formularserver.bayern.de herunterzuladen';
        downloadAttribute = '';
      }
      if(url.match(/regierung\.oberfranken/)) {
        clicktext = 'Klicken um von regierung.oberfranken.bayern.de herunterzuladen';
        downloadAttribute = '';
      }
        formUrls.push(`<div class="d-none"><a class="btn btn-sm btn-success mx-2 my-1 w-100 text-left" href="${downloadUrl}" ${downloadAttribute} data-action="click->formularcenter#removeLink">Download ${i+1}/${formLinksCount}<br> ${link.textContent}<br>${clicktext}</a></div>`);

      i++;
    }.bind(this));

    this.button.insertAdjacentHTML("afterend", `<div id="direct-download-links">${formUrls.join(' ')}</div>`)

    this.showFirstDirectDownloadLink();
    // Return or use the collected URLs
    return formUrls;
  }

  showFirstDirectDownloadLink() {
    let firstItem = document.getElementById('direct-download-links').querySelector("div");
    if(firstItem) {
      firstItem.classList.remove('d-none');
    }
  }

  formularTitle(formUrl) {
    const urlParts = formUrl.split('/');
    const title = urlParts[urlParts.length - 2];
    return title;
  }

  removeLink(event) {
    const button = event.target.closest('a.btn');
    button.insertAdjacentHTML('beforeend', this.spinner());

    // wait a little before removing the link as the download will not
    // start immediately
    setTimeout(() => {
      const link = event.target.closest('div');
      link.remove();
      this.showFirstDirectDownloadLink();
    }, 500);
  }
}
